exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".off-1 {\n    fill: #e6e6e6;\n  }\n\n.off-2 {\n    fill: #fff;\n  }", ""]);
